import script from "./contactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./contactUs.vue?vue&type=script&setup=true&lang=js"

import "./contactUs.vue?vue&type=style&index=0&id=2ef4e0de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef4e0de"]])

export default __exports__